

const ATTRIBUTE_TAG_NAMESPACES = [
  "color",
  "fabric",
  "style",
  "sleeve_type",
  "silhouette",
  "neckline",
  "features",
  "bridalparty",
  "product_type",
  "style_group",
  "delivery_time",
];

function normalizeSearchValue(value) {
  return String(value || "")
    .trim()
    .replace(/\s+/g, " ");
}

function titleCase(value) {
  return normalizeSearchValue(value)
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

function tagValueCandidates(value) {
  const normalized = normalizeSearchValue(value);

  if (!normalized) return [];

  return Array.from(new Set([normalized, normalized.toLowerCase(), titleCase(normalized)]));
}

export function escapeForQuotedValue(value) {
  return String(value || "")
    .replace(/\\/g, "\\\\")
    .replace(/"/g, '\\"');
}

export function buildAttributeScopedSearchQuery(term) {
  const trimmed = normalizeSearchValue(term);

  if (!trimmed) {
    return trimmed;
  }

  if (trimmed.toLowerCase() === "all") {
    return "*";
  }

  const clauses = new Set();

  clauses.add(`title:"${escapeForQuotedValue(trimmed)}"`);

  clauses.add(`tag:"${escapeForQuotedValue(trimmed)}"`);

  ATTRIBUTE_TAG_NAMESPACES.forEach((namespace) => {
    tagValueCandidates(trimmed).forEach((value) => {
      clauses.add(`tag:"${escapeForQuotedValue(`${namespace}:${value}`)}"`);
    });
  });

  return `(${Array.from(clauses).join(" OR ")})`;
}
